import {
  CHANGE_ALERT_VISIBLE,
  CHANGE_ALERT_TYPE,
  CHANGE_ALERT_TEXT
} from './actions'

export default function(state = {
  visible: false,
  type: 'notification',
  // text: '<span>Clique aqui para habilitar notificações</span> dos seus casos em tempo real'
  text: 'Com Acordo precisa do seu <span>clique para habilitar notificações via navegador</span>'
}, action) {
  switch(action.type) {
    case CHANGE_ALERT_VISIBLE:
      return { ...state, visible: action.payload }
    case CHANGE_ALERT_TYPE:
      return { ...state, type: action.payload }
    case CHANGE_ALERT_TEXT:
      return { ...state, type: action.payload }
    default:
      return state
  }
}
